export default (state, action) => ({
  ...state,
  devices: action.payload,
  devicesInitialized: true,
  noDevices: !action.payload.length,
})
